import { createApp } from 'vue';
import Antd from 'ant-design-vue';
import router from './router/Index';
import App from './App.vue';
import 'ant-design-vue/dist/antd.css';
import './assets/css/quill.core.css';
import './assets/css/quill.snow.css';
import './assets/css/quill-font.css';
import MapContainer from './components/MapContainer.vue';
import 'amfe-flexible'
const app = createApp(App);

app.use(Antd).use(router).component('MapContainer', MapContainer).mount('#app');
